import { createSlice } from '@reduxjs/toolkit';
import type { UiState } from '@/types';

const initialState: UiState = {
  sidebarOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    sidebarToggled(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    sidebarClosed(state) {
      state.sidebarOpen = false;
    },
  },
});

export const { sidebarToggled, sidebarClosed } = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
